import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-escolaridade-pf',
  templateUrl: './escolaridade-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./escolaridade-pf.component.css']
})
export class EscolaridadePfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.escolaridade===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.escolaridade===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
